import { render, staticRenderFns } from "./BatchActionAddProductsSuggestions.vue?vue&type=template&id=0ac24a89"
import script from "./BatchActionAddProductsSuggestions.vue?vue&type=script&lang=js"
export * from "./BatchActionAddProductsSuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports